import React from "react";

interface KeyPanelProps {
  handleAddKey: () => void;
}

const KeyPanel: React.FC<KeyPanelProps> = ({ handleAddKey }) => (
  <div className="keyPanel">
    <div className="keyPanelContent">
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          width: "50%",
        }}
      >
        <h1>Schlüssel</h1>
        <div className="buttonB" onClick={handleAddKey}>
          <img
            src={"/img/configurator/plus.svg"}
            alt="minus"
            style={{ width: "20px", height: "20px" }}
          />
        </div>
      </div>
      <p>Stück</p>
    </div>
  </div>
);

export default KeyPanel;
